import React from 'react';
import styled from 'styled-components';
import useFundsStateStore from '../../../common/funds-state-hook';
import { DropdownContainer, DropdownText } from '../../../common/dropdown/styles';
import { SDropdownIcon } from '../common';

const SDropdownContainer = styled(DropdownContainer)`
  margin-right: 10px;
  padding: 8px 16px;

  &.active {
    background-color: #EFF1F6;
  }
`;

export default function Desktop() {
  const set = useFundsStateStore(state => state.set);
  const fundTypes = useFundsStateStore(state => state.appliedFilters.fundTypes);

  const onClick = () => {
    set(state => {
      state.showFundTypesModal = true;
    });
  };

  return (
    <SDropdownContainer className={fundTypes.length > 0 ? 'active' : ''} onClick={onClick}>
      <DropdownText>Type</DropdownText>
      <SDropdownIcon className="icon-lw icon-lw-chevron-down" />
    </SDropdownContainer>
  );
}
